var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 11.75a68.37 68.37 0 003.496-.078c.404 0 .746-.153 1.025-.46.28-.305.42-.68.42-1.122a37.671 37.671 0 000-4.18c0-.443-.14-.817-.42-1.123a1.337 1.337 0 00-1.025-.459 61.585 61.585 0 00-3.32-.078h-.352c-1.263 0-2.37.026-3.32.078-.404 0-.742.153-1.016.46-.273.305-.41.68-.41 1.122A41.536 41.536 0 003 8c0 .69.02 1.387.059 2.09 0 .443.14.817.42 1.123.28.306.621.459 1.025.459A68.37 68.37 0 008 11.75zm-.957-1.836V6.066L9.875 8 7.043 9.914z","fill":"currentColor","fillRule":"nonzero"}));
}

YoutubeInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
